import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppinitService {

  constructor() { }

  public init() {

    return from(
      Promise.all([
        fetch(environment.configURL).then(function (response) {
          return response.json();
        }),
        fetch(environment.translationURL).then(function (response) {
          return response.json();
        })
      ])).pipe(
        map((config) => {
          environment.gmsConfig = config[0];
          environment.translations = config[1];
          if (environment.gmsConfig["isReplaceURLs"]) {
            environment.urls = environment.gmsConfig["urls"];
          }
          console.log('environment.gmsConfig:', environment.gmsConfig);
          return;
        })).toPromise();
  }
}
export function init_app(appLoadService: AppinitService) {
  return () => appLoadService.init();
}










